<template>
  <div>
    <span v-if="hasEntitlementType(app) && app.access.display_type === 'html'"
      v-html="app.access.state"></span>
    <p v-else v-bind:title="parseEntitlementString(app.access.state)">{{parseEntitlementString(app.access.state) | truncate(truncate) }} </p>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  mapGetters
} from 'vuex'
import * as CONSTANTS from '../constants.js'
import AppHandlerMixin from "@/mixins/AppHandlerMixin";

export default {
  name: 'EntitlementDisplay',
  components: {},
  mixins: [AppHandlerMixin],
  props: {
    app: Object,
    truncate: Number
  },
  data: function () {
    return {
      CONSTANTS
    }
  },
  computed: {
  },
  mounted () {

  },
  methods: {
    
  }
}
</script>

<style scoped>

</style>
